exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html {\n  box-sizing: border-box;\n}\n\n*, *:before, *:after {\n  box-sizing: inherit;\n}\n\nul {\n  margin-top: 0px;\n  margin-bottom: 0px;\n  padding-left: 0px;\n  list-style: none;\n}\n\noption {\n  margin: 0px;\n  padding: 0px;\n}\n", ""]);

// exports
